import { motion } from 'framer-motion';
import React from 'react';
import { MenuItem } from '../../interfaces/menu-item';
import NavItem from '../atoms/NavItem';
import CustomLink from '../atoms/Link';
import { getMenuItemUrl } from '../../helpers/menu-item';
import { useLockBodyScroll } from 'react-use';

type Props = {
  items: MenuItem[];
  ctaItems: MenuItem[];
};

export const MobileMenu = ({ items, ctaItems }: Props) => {
  useLockBodyScroll();

  return (
    <motion.div
      className="absolute left-0 right-0 z-50 overflow-hidden overflow-y-auto bg-white shadow lg:hidden top-full"
      style={{ maxHeight: 'calc(100vh - 64px)' }}
      initial={{ height: 0 }}
      animate={{ height: 'auto' }}
      exit={{ height: 0 }}
    >
      <div className="px-5 py-6">
        <ul className="block px-5 pb-6 -mx-5 space-y-6 border-b border-slate-100">
          {items.map((item) => (
            <li key={item.label}>
              <NavItem item={item} />
            </li>
          ))}
        </ul>
        <ul className="py-6 space-y-3">
          {ctaItems.map((item, index) => (
            <CustomLink
              key={index}
              className={`w-full block px-6 py-3 text-sm font-semibold transition rounded focus:outline-none u-ring ${
                item.targetPage?.url === '/pricing'
                  ? 'text-white bg-primary hover:bg-opacity-90 focus:bg-opacity-90 text-center'
                  : 'text-slate-700 hover:bg-slate-100 focus:bg-slate-100 text-center border border-slate-200'
              }`}
              href={getMenuItemUrl(item)}
            >
              {item.label}
            </CustomLink>
          ))}
        </ul>
      </div>
    </motion.div>
  );
};
